module.exports = __webpack_public_path__ + "img/Orkney Islands.9b4e7d1d.svg";